import React from 'react';
import { Popup as SemanticPopup, PopupProps } from 'semantic-ui-react';

const Popup = (props: PopupProps) => {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <SemanticPopup size="mini" basic inverted {...props} />;
};

export default Popup;
